/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".estadoTimbrar1[_ngcontent-%COMP%]{background-color:#c0fdcf!important}.estadoTimbrar2[_ngcontent-%COMP%], .estadoTimbrar3[_ngcontent-%COMP%], .estadoTimbrar4[_ngcontent-%COMP%], .estadoTimbrar5[_ngcontent-%COMP%]{background-color:#da8888!important}"];
export { styles as styles };
